import { ColumnConfig, DynamicSegmentsReportColumnKey } from '../../model';

export const DynamicSegmentsReportConfig: Record<
  DynamicSegmentsReportColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S. No',
  },
  segmentsName: {
    name: 'Segments Name',
  },
  description: {
    name: 'Description',
  },
  rule: {
    name: 'Rule',
    isComponent: true,
    isVisible: false,
  },
  totalCustomers: {
    name: 'Total Customers',
    alignment: 'flex-end',
  },
  actions: {
    name: 'Actions',
    isComponent: true,
    alignment: 'flex-end',
  },
};
